import React from 'react';
import '../styles/services.css';

const PERFIL_URL = 'https://miperfil.institutobilinguelasnaciones.com/';

const especialidades = [
  {
    id: 'fonoaudiologia',
    title: 'Fonoaudiología',
    image: 'service-fonoaudiologia.png',
    imageAlt: 'Fonoaudiología',
    description:
      'Si eres fonoaudiólogo o fonoaudióloga, puedes sumarte al equipo que acompaña la comunicación, el lenguaje y la deglución.',
  },
  {
    id: 'integracion-sensorial',
    title: 'Integración Sensorial',
    image: 'service-integracion-sensorial.png',
    imageAlt: 'Integración sensorial',
    description:
      'Buscamos profesionales de integración sensorial para atender a quienes necesitan organizar los estímulos de su día a día.',
  },
  {
    id: 'terapia-ocupacional',
    title: 'Terapia Ocupacional',
    image: 'service-terapia-ocupacional.png',
    imageAlt: 'Terapia ocupacional',
    description:
      'Terapeutas ocupacionales que quieran promover autonomía y participación en las actividades de la vida diaria.',
  },
  {
    id: 'psicologia',
    title: 'Psicología',
    image: 'service-psicologia.png',
    imageAlt: 'Psicología',
    description:
      'Psicólogos y psicólogas para acompañar emociones, pensamientos y conductas, en un entorno de apoyo a las familias.',
  },
  {
    id: 'modificacion-conducta',
    title: 'Modificación de Conducta',
    image: 'service-modificacion-conducta.png',
    imageAlt: 'Modificación de conducta',
    description:
      'Profesionales con experiencia en conducta que deseen trabajar técnicas de aprendizaje y adaptación.',
  },
  {
    id: 'estimulacion-temprana',
    title: 'Estimulación Temprana',
    image: 'service-estimulacion-temprana.png',
    imageAlt: 'Estimulación temprana',
    description:
      'Especialistas en primera infancia para favorecer el desarrollo integral en los primeros años de vida.',
  },
  {
    id: 'terapia-familiar',
    title: 'Terapia Familiar',
    image: 'service-terapia-familiar.png',
    imageAlt: 'Terapia familiar',
    description:
      'Profesionales que quieran orientar a las familias y fortalecer su capacidad de afrontar los desafíos juntos.',
  },
];

const JoinUsPage = () => {
  return (
    <div className="services-root">
      <section className="services-section services-section-intro">
        <div className="services-hero-card">
          <h1 className="services-hero-title">Sé parte de nosotros</h1>
          <p className="services-hero-text">
            Si eres profesional en fonoaudiología, integración sensorial, terapia ocupacional,
            psicología u otra especialidad afín, puedes postularte para trabajar con Beyond.
            Elige tu área y completa tu perfil en Mi Perfil.
          </p>
        </div>
      </section>

      <section className="services-section services-section-catalog">
        <div className="services-catalog-inner">
          {especialidades.map((item) => (
            <article key={item.id} className="services-catalog-card">
              <div className="services-catalog-visual">
                <img
                  src={`${process.env.PUBLIC_URL}/images/${item.image}`}
                  alt={item.imageAlt}
                  className="services-catalog-photo"
                />
              </div>

              <div className="services-catalog-body">
                <h2 className="services-catalog-title">{item.title}</h2>
                <p className="services-catalog-description">{item.description}</p>
              </div>

              <a
                className="services-catalog-buy"
                href={PERFIL_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Postúlate
              </a>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default JoinUsPage;
